// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image__details__popup--container {
    position: fixed;
    inset: 0px;
    z-index: 20
}
.image__details__popup--row {
    position: relative;
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
    background-color: #0000003b
}
.image__details__popup--col {
    position: absolute;
    z-index: 10;
    height: auto;
    width: auto;
    border-radius: 0.375rem;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1))
}`, "",{"version":3,"sources":["webpack://./src/components/ImageDetails/imageDetails.css"],"names":[],"mappings":"AACI;IAAA,eAAyB;IAAzB,UAAyB;IAAzB;AAAyB;AAGzB;IAAA,kBAA6E;IAA7E,aAA6E;IAA7E,YAA6E;IAA7E,WAA6E;IAA7E,mBAA6E;IAA7E,uBAA6E;IAA7E;AAA6E;AAG7E;IAAA,kBAAwD;IAAxD,WAAwD;IAAxD,YAAwD;IAAxD,WAAwD;IAAxD,uBAAwD;IAAxD,kBAAwD;IAAxD;AAAwD","sourcesContent":[".image__details__popup--container {\n    @apply fixed inset-0 z-20;\n}\n.image__details__popup--row {\n    @apply w-full h-full relative bg-[#0000003b] flex items-center justify-center;\n}\n.image__details__popup--col {\n    @apply absolute z-10 bg-white w-[auto] h-auto rounded-md;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
